import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

import { signUp, resendVerificationEmail, signUpGoogle, signInGoogle } from "../../actions/authActions";
import { renderSteps, renderAccountPage, renderBusinessPage, renderSignupPage, renderAuthPage, renderAlreadyAccount } from "./signUpComponents";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import history from "../../history";
import LogoName from "../Logo";

const SignUp = (props) => {
    const [searchParams] = useSearchParams();
    const [activeStep, setActiveStep] = useState(0)
    const [emailSent, setEmailSent] = useState(false)
    const [socialValues, setSocialValues] = useState({})
    const [passwordFlow, setPasswordFlow] = useState(false)

    useEffect(() => {
        if (searchParams.get('flow')) {
            setActiveStep(1)
            setSocialValues(
                {
                    'flow': searchParams.get('flow'),
                    'firstname': searchParams.get('firstname'),
                    'lastname': searchParams.get('lastname'),
                    'email': searchParams.get('email'),
                    'verified': Boolean(searchParams.get('verified'))
                }
            );
            history.push('/signup')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleNext = () => {
        if (activeStep === 0 && !passwordFlow) {
            setPasswordFlow(true);
        }
        else {
            setActiveStep(activeStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const onSignUpGoogle = () => {
        props.signInGoogle()
    }

    const onSubmit = (formValues) => {
        if (passwordFlow) {
            props.signUp(formValues);
        }
        else {
            props.signUpGoogle({ ...formValues, ...socialValues }) // Merge thew two objects formValues and socialValues
        }
        setActiveStep(activeStep + 1);
    }

    const onResend = (email) => {
        props.resendVerificationEmail({ 'email': email });
        setEmailSent(true)
    }
    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <Grid
                item
                xs={false}
                sm={4}
                md={4}
                sx={{
                    background: theme =>
                        `linear-gradient(to bottom right, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute', // Position the Typography absolutely
                        top: 16, // Adjust top margin
                        left: 16, // Adjust left margin
                        zIndex: 10, // Ensure it appears above other elements
                        color: 'white', // Ensure readability against the background
                    }}
                >
                    <LogoName />
                </Box>
                <Box
                    sx={{
                        my: 28,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',

                    }}
                >
                    <Typography component="h1" variant="h5" sx={{ mb: 5, color: 'white' }}>
                        Create your account
                    </Typography>
                    {renderSteps(activeStep)}
                    {renderAlreadyAccount()}
                </Box>

            </Grid>
            <Grid item xs={12} sm={8} md={8} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        mx: 1,
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}
                >
                    {activeStep === 0 & !passwordFlow ?
                        renderAuthPage(handleNext, onSignUpGoogle)
                        : null
                    }
                    {activeStep === 0 & passwordFlow ?
                        renderAccountPage(handleNext)
                        : null
                    }
                    {activeStep === 1 &&
                        renderBusinessPage(onSubmit, socialValues.flow)}
                    {activeStep === 2 &&
                        renderSignupPage(props.signup.email, passwordFlow, emailSent, onResend)}
                    {activeStep > 0 && activeStep < 2 && passwordFlow ?
                        <Button variant="text" onClick={() => { handleBack() }}>
                            <ArrowBackIcon /> Back
                        </Button>
                        : null}
                </Box>
            </Grid>
        </Grid >
    );

}

const mapStateToProps = (state) => {
    return {
        isRefreshing: state.auth.isRefreshing,
        signup: state.signup
    }
}

export default connect(mapStateToProps, { signUp, resendVerificationEmail, signUpGoogle, signInGoogle })(SignUp)